import { HttpClient } from '@remodeling/base';
import {
  GetSharedUntactSuggestDetailRequest,
  GetSharedUntactSuggestDetailResponse,
} from '../../model/dto';

export class GetSharedUntactSuggestDetailGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetSharedUntactSuggestDetailRequest) {
    return await this.httpClient.request<GetSharedUntactSuggestDetailResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/shared/untact/${req.randomPath}`,
    });
  }
}
